const updateTheme = () => {
  const colorScheme = document.querySelector('meta[name="color-scheme"]')?.getAttribute('content');
  const prefersDark = globalThis.matchMedia('(prefers-color-scheme: dark)').matches;
  const hasDark = !!colorScheme?.includes('dark');
  const hasLight = !!colorScheme?.includes('light');
  const isDark = (hasDark || hasLight) ? hasDark : prefersDark;
  document.documentElement.classList.remove('theme-light', 'theme-dark');
  document.documentElement.classList.add(`theme-${isDark ? 'dark' : 'light'}`);
};

updateTheme();

globalThis.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme);

const target = document.querySelector('meta[name="color-scheme"]');
if (target) new MutationObserver(updateTheme).observe(target, { attributes: true, attributeFilter: ['content'] },);


(() => {
  if (CSS.supports('field-sizing', 'content')) return;

  const adjustSize = (textarea: HTMLTextAreaElement) => {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const polyfillFieldSizing = () => {

    document.querySelectorAll('textarea').forEach((textarea) => {
      textarea.addEventListener('input', () => adjustSize(textarea));
    });
  };

  setInterval(() => {
    document.querySelectorAll('textarea').forEach(adjustSize);
  }, 100);

  const observer = new MutationObserver(() => polyfillFieldSizing());

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('DOMContentLoaded', polyfillFieldSizing);
})();